import { HER_ACTIONS } from "../../actions/herActions";

const headerReducer = (state = {
  data: null
}, action) => {
  switch (action.type) {
    case HER_ACTIONS.FETCH_HEADER_DATA:
      state = {
        ...state,
        data: action.payload
      }
      break;
    default:
      break;
  }
  return state;
};

export default headerReducer;
